<template>
  <div
    class="file-content-container"
  >
    <v-layout>
      <v-flex
        mb2
      >
        <v-img
          :src="logo"
          width="320"
          class="mb-5"
          data-cy="logo"
        />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import logo from '~/assets/images/logos/ncino-closing-mono-light.svg'

export default {
  name: 'ClosingPortalLogo',

  data () {
    return {
      state: null,
      initKey: '',
      email: '',
      logo: logo,
      titleText: 'Closing Portal'
    }
  }
}
</script>
